import React, {PureComponent} from 'react';
import ReactDOM from "react-dom";
import PropTypes from 'prop-types';
import Answer from "./Answer";
import Sortable from "react-sortablejs";

class Target extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      draggingLine: false,
    };

    this.onDrag = this.onDrag.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  getDraggingLine(evt) {
    const questionScale = this.props.question.valueMax - this.props.question.valueMin;
    const targetWidth = ReactDOM.findDOMNode(this).getBoundingClientRect().width;
    const targetLeft = ReactDOM.findDOMNode(this).getBoundingClientRect().left;
    const elementLeft = evt.clientX;
    let elementOffsetX = elementLeft - targetLeft;
    let finalOffset = (((elementOffsetX / targetWidth) * questionScale) + Number(this.props.question.valueMin));
    let powDecimals = Math.pow(10, this.props.question.decimals);
    let value = Number(finalOffset * powDecimals).toFixed(0);

    if(value > Number(this.props.question.valueMax * Math.pow(10, this.props.question.decimals))){
      value = Number(this.props.question.valueMax * Math.pow(10, this.props.question.decimals)).toFixed(0);
      elementOffsetX = targetWidth;
    }
    if(value < Number(this.props.question.valueMin * Math.pow(10, this.props.question.decimals))){
      value = Number(this.props.question.valueMin * Math.pow(10, this.props.question.decimals)).toFixed(0);
      elementOffsetX = 0;
    }

    return {
      offsetLeft: elementOffsetX,
      value
    }
  }

  onDrag(evt) {
    const draggingLine = this.getDraggingLine(evt);
    this.setState({draggingLine});
  }

  onDrop(evt) {
    const { answers, question, details } = this.props;
    const event = evt.originalEvent instanceof MouseEvent ? evt.originalEvent : evt.originalEvent.changedTouches[0];
    const draggingLine = this.getDraggingLine(event);

    this.props.handleDrop(parseInt(evt.item.dataset.a), parseInt(draggingLine.value));
    setTimeout(() => {
      const currentEl = document.getElementById('a-' + evt.item.dataset.a)
      const currentRect = currentEl.getBoundingClientRect()
      let overlapCount = 0;

      details.forEach((detail) => {
        if (Number(detail.answer) !== Number(evt.item.dataset.a)) {
          const el1 = document.getElementById('a-' + detail.answer);
          if (el1) {
            var rect1 = el1.getBoundingClientRect();

            if (rect1 && currentRect) {

              var overlap = !(
                  rect1.right < currentRect.left ||
                  rect1.left > currentRect.right
              );
              if (overlap) {
                overlapCount++;
              }
            }
          }
        }
      })

      switch (overlapCount) {
        case 0:
          currentEl.style.top = "40%"
          break;
        case 1:
          currentEl.style.top = "10%"
          break;
        default:
          currentEl.style.top = "70%"
      }
    })

    this.setState({draggingLine: false});
  }

  render() {
    const { answers, question, details } = this.props;
    const {draggingLine} = this.state;

    return <Sortable
      className="target"
      options={{
        group: {
          name: 'numericMulti-target-' + question.id,
          put: ['numericMulti-answers-' + question.id, 'numericMulti-target-' + question.id],
        },
        animation: 100,
        onEnd: this.onDrop
      }}
      onChange={(order, sortable, evt) => this.onDrop(evt)}
    >
      {answers.map((answer) => {
        return <Answer
          key={'a' + answer.id}
          isActive={true}
          answer={answer}
          details={details}
          question={question}
          setHighestAnswerHeight={this.props.setHighestAnswerHeight}
          highestAnswerHeight={0}
          setDragging={this.onDrag}
        />
      })}
      {draggingLine && <div className="line-wrapper" style={{
        left: draggingLine.offsetLeft + 'px',
      }}>
        <span className="value">{Number((draggingLine.value / Math.pow(10, question.decimals))).toFixed(question.decimals)}</span>
      </div>}
      {details.map((detail) => {
        if (draggingLine) {
          return <React.Fragment/>
        }

        return <div className="line-wrapper" style={{
          left: detail.value1 + '%',
        }}>
        </div>
      })}
    </Sortable>;
  }
}

Target.propTypes = {
  question: PropTypes.shape({
    answersImage: PropTypes.bool.isRequired,
  }).isRequired,
  answers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
  }),).isRequired,
  handleDrop: PropTypes.func.isRequired,
  setHighestAnswerHeight: PropTypes.func.isRequired,
};

export default Target;